import { trackRecorder } from '@shared/utils/event/base/recorder';
import GoogleTrack from '@shared/utils/tracker/googleTrack';
import eventTracker, { LoggingAction } from '..';

//用户支付的行为线
type actionType =
	| LoggingAction.PAY_RESULT
	| LoggingAction.PRICING_POPUP
	| LoggingAction.PAY_PLAN_POPUP
	| LoggingAction.PRICING_PREMIUM_SUBSCRIBE_CLICK
	| LoggingAction.GOOGLE_PLAY_POPUP_CLOSE_MANUALLY
	| LoggingAction.PURCHASE_CREDITS_BUTTON_CLICK
	| LoggingAction.CREDITS_POPUP
	| LoggingAction.PURCHASE_CREDITS_RESULT
	| LoggingAction.PAY_CANCEL_RECOVERY
	| LoggingAction.PAY_CANCEL_RECOVERY_CLICK;

export enum HalfPurchasePopupType {
	NoWatermark = 'noWatermark',
	EnhanceImage = 'enhanceImage',
	VipApp = 'vipApp',
	TaskPending = 'taskPending',
	FaceSwapUpload = 'faceSwapUpload',
	CutOutPro = 'segment',
	DressUp = 'dress_up',
	IDPhoto = 'id_photo',
	Resolution = 'resolution', // 分辨率权益的半屏定价页弹窗
	PrivateMode = 'private_mode', // Remix 私密模式半屏定价页
	Result_Multiple = 'result_multiple', // 生成多结果
}

/**
 * 付费位置
 * @description 这里枚举变量命名不规范，后续需要规范一下
 */
export enum PaymentLocation {
	generate = 'generate', // 生成时算力为0
	generateBuild = 'generate_build',
	generateFork = 'generate_fork',
	generateRemix = 'generate_remix',
	ProfileRenew = 'profile_renew', // 个人
	upgrade = 'upgrade',
	removeWatermark = 'remove_watermark',
	downloadNoWatermark = 'download_no_watermark',
	generationWait = 'generation_wait',
	enhanceImage = 'enhance',
	secondGeneration = 'second_generation',
	vipApp = 'vip_app',
	reach3limit = 'generate_reach3limit',
	reach2limit = 'generate_reach2limit', // 暂时没地方用
	downloadLocked = 'download_locked',
	API_PAGE = 'api_page',
	GEN_FAILURE_GUIDE = 'gen_failure_guide',
	payRetainTriggerDiscount = 'pay_retain_trigger_discount',
	payRetainLowPrice = 'pay_retain_low_price',
	upgradeHome = 'upgrade_home', //首页的升级入口——不知道什么地方该用
	cancelRetain = 'cancel_retain', // 取消续订低价升级挽留
	faceSwapUpload = 'Custom_Face_Swap', // 上传视频模板
	Banner = 'banner', // 取消续订低价升级挽留
	RenewRetention = 'renewal_retention', // 续订激励弹窗
	TaskSuspensionLimit = 'task_suspension_limit', // 任务队列限制弹窗
	NoCreditBubbleTip = 'credit_0_home', // 首页算力为0的气泡弹窗
	FirstScreenRenewalRecovery = 'first_screen_renewal_recovery',
	PayCancelRecovery = 'pay_cancel_recovery',
	CheckInPage = 'check_in_page', // 签到弹窗打开付费弹窗
	CheckInPopup = 'check_in_v3_popup', // 签到弹窗打开付费弹窗
	CreditsDetailPage = 'credits_detail_page', // 算力详情页
	Generate_VIP = 'generate_VIP', // Standard VIP 积分为0
	Task_Suspension_Limit_VIP = 'task_suspension_limit_VIP', // Standard VIP 任务队列限制弹窗

	Onboard_First = 'onboard_first',
	Old_User_Pay_Guide = 'old_user_first_screen_strategy', // 老用户付费引导弹窗
	Cold_Start_Commend = 'cold_start_commend', // 冷启动内容承接弹窗
	Old_User_Pay_Guide_More_Packgae = 'more_packpage', // 老用户付费引导弹窗--更多套餐按钮
	Upgrade_To_Annual_Home_Open = 'plus_year_upgrade_home', // 升级年费弹窗--首页打开
	Upgrade_To_Annual_Zero_Credit = 'plus_year_0_credits', // 升级年费弹窗--零积分打开
	Upgrade_To_Annual_Home_Open_More = 'plus_year_upgrade_home_more', // 升级年费弹窗--首页打开--更多套餐
	Upgrade_To_Annual_Zero_Credit_More = 'plus_year_0_credits_more', // 升级年费弹窗--零积分打开--更多套餐
	Resolution = 'resolution_detail', // 这个是Resolution半屏定价页
	ResolutionResult = 'resolution_result', // 这个是Resolution半屏定价页(结果页弹的时候)
	Generate_Process = 'generate_process', // 生成过程中付费
	RemixPrivateMode = 'remix_private_mode', // Remix 选择仅自己可见时调起的私密模式定价弹窗
	Result_Multiple = 'multi_styles_results', // 生成多结果

	// 加量包相关
	Generate_0 = 'generate_0', // 会员不足
	Credits_Pack_Retain = 'credits_pack_retain', // 小额积分包挽留
	Credit_Detail_1001 = 'credit_detail_1001', // 积分详情页1001积分购买入口

	Credits_Below_One_Third = 'credits_below_one_third', // 积分不足1/3时弹窗
	Credits_Below_One_Fifth = 'credits_below_one_fifth', // 积分不足1/5时弹窗

	// 亲密度路线图解锁
	ChatbotRelationship = 'chatbot_relationship',

	// Purchase Boost 实验弹窗
	splash_display = 'splash_display',
}

export enum PriceType {
	lowPriceType = 'low_price_type',
	highPriceType = 'high_price_type',
}

interface PaymentCache {
	location: PaymentLocation;
	price_page_type: PriceType;
	app_id?: string;
	post_id?: string;
	chatbot_id?: string;
	function_type?: PayFor;
	[key: string]: any;
}

/** 为什么目的而付费 */
export enum PayFor {
	Generate = 'generate',
	ChatbotConversation = 'chatbot_conversation',
	ChatbotViewImg = 'chatbot_view_img',
	ChatbotSendPhoto = 'chatbot_send_photo',
	ChatbotImg2Video = 'chatbot_img_to_video',
	ChatbotSnapCouple = 'chatbot_snap_couple',
	ChatbotSnapCharacter = 'chatbot_snap_character',
	ChatbotCustomCouple = 'chatbot_custom_couple',
	ChatbotCustomCharacter = 'chatbot_custom_character',
	ChatbotCustomMe = 'chatbot_custom_me',
	ChatbotViewImgCouple = 'chatbot_view_img_couple',
	ChatbotRelationship = 'chatbot_relationship',
}

export class PaymentDataWareEvent {
	cache: PaymentCache = {
		location: PaymentLocation.generate,
		price_page_type: PriceType.lowPriceType,
	};
	getCacheKey(key: string) {
		return (this.cache as any)[key];
	}
	setCacheKey(key: string, value: string | boolean | undefined) {
		(this.cache as any)[key] = value;
	}
	deleteCacheKey(key: string) {
		delete (this.cache as any)[key];
	}
	/**  @deprecated 近期将移动到新埋点体系，使用postProcessor来处理数据 */
	dataWareHandle(action: actionType, data: object) {
		const mergeData = { ...Object.assign(this.cache, data) };

		if (this.cache.function_type === 'generate') {
			delete mergeData.chatbot_id;
		} else {
			delete mergeData.app_id;
		}
		eventTracker.loggingEvent(action, mergeData);
		// delete this.cache['app_id'];
		delete this.cache['post_id'];
		if (action === LoggingAction.PAY_RESULT) {
			GoogleTrack.subscribeTrack();
		}
	}
	constructor() {}

	// 暂未启用, 目前和dataWareHandle看起来差不多，但是现在没能拿到action
	postProcessor(data: object) {
		Object.assign(this.cache, data);
		const mergeData = { ...Object.assign(this.cache, data) };
		if (this.cache.function_type === 'generate') {
			delete mergeData.chatbot_id;
		} else {
			delete mergeData.app_id;
		}
		delete this.cache['post_id'];
		return mergeData;
	}
}

export const paymentDataWareEvent = new PaymentDataWareEvent();

export const parsePricingPopupOrigin = (appId?: string, postId?: string) => {
	const { generateLocation, generateInPost } = trackRecorder.source;
	if (generateLocation === 'post_detail' && generateInPost) {
		paymentDataWareEvent.setCacheKey('post_id', generateInPost);
	}
	if (postId) {
		paymentDataWareEvent.setCacheKey('post_id', postId);
	}
	if (appId) {
		paymentDataWareEvent.setCacheKey('app_id', appId);
	}
};
